import React, { useEffect, useState, Fragment } from 'react';
import OTPInput from 'otp-input-react';
import './emailPopup.scss';
import { showServiceError, stopBackgroundScrolling } from '../../../common/utils/app.utils';
import { sendEmailForOrderAuthentication, sendOTPForSummary, verifyOTPForSummary, getOrderConfirmationUsers } from '../../../common/services/http.service';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Button from 'b2b-ui-components-lib/lib/components/button';

import { faOnDedicatedEmailPopupLoad, faOnDedicatedEmailPopupSubmit } from '../../services/analytics.service';
import { getEmailHeaderText } from '../summary/summary.constant';
import { NOTIFICATION_MESSAGE } from 'home/view/manage-feasibility/constants/multiSite-constants';
import { GENERIC_ERROR_MESSAGE, isAOIOrder } from 'common/constants/app.constants';
import refreshIcon from 'assests/svg/refresh.svg';
import { checkIfObjectHasValue } from 'common/utils/app.utils';
import AddReviewer from './addReviewers';
import classNames from 'classnames';
import { MultiSelectDropDownWithSearch } from 'featureLib';
import { getCurrentOrder } from 'tokenGeneration/lead.util';

const getOptionListForEmail = (customer, isOrderConfirmation, emails) => {
  const userEmail = customer && customer.journeyInitiator && customer.journeyInitiator.email;
  const otherContacts = customer && customer.otherContacts && customer.otherContacts.length && customer.otherContacts;
  return (
    Array.isArray(otherContacts) &&
    otherContacts
      ?.map((item) => ({
        displayName: isOrderConfirmation ? item?.designation + ' | ' + item?.email : item.email,
        key: item.email,
        isCurrentUser: userEmail === item.email,
        helpText: item?.designation
      }))
      .filter((option) => {
        return isOrderConfirmation ? emails?.includes(option?.key) : true;
      })
  );
};

const EmailPopup = ({
  customer,
  setshowPopup,
  email,
  setOTPVerification,
  isMultiSite = false,
  setNotification = () => {},
  orderStatus,
  fetchOrder = () => {},
  isOrderConfirmation = false,
  setCustomerDetail,
  updatedEmail = '',
  order,
  planDetail
}) => {
  const [OTP, setOTP] = useState('');
  const [shouldTriggerOTP, setShouldTriggerOTP] = useState(false);
  const [invalidOTP, setInvalidOTP] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sentEmailId, setSentEmailId] = useState(email);
  const [refreshing, setRefreshing] = useState(false);
  const [optionsList, setOptionsList] = useState(getOptionListForEmail(customer, isOrderConfirmation, email));
  let reviewersList = {};
  const findOptionbyEmail = () => {
    if (isAOIOrder()) {
      return {
        key: updatedEmail || customer?.authorizedSignatory?.email,
        // displayName: customer?.designation + ' | ' + customer?.customerEmail,
        displayName: updatedEmail || customer?.authorizedSignatory?.email,
        isCurrentUser: false
      };
    }
    const optionByEmail = optionsList && optionsList.find((option) => option.key === email);
    return optionByEmail ? optionByEmail : optionsList.length > 0 ? optionsList?.[0] : [];
  };

  const [emailId, setSelectedEmailId] = useState(findOptionbyEmail());
  const [selectedOption, setSelectedOption] = useState([]);

  const onChangeOTP = (value) => {
    setOTP(value);
    setInvalidOTP(false);
  };

  const initiateOTP = () => {
    setIsLoading(true);
    let payLoad = {};
    if (emailId && emailId.key) {
      payLoad.email = emailId.key;
    }
    sendOTPForSummary(payLoad, isMultiSite)
      .then((response) => {
        setShouldTriggerOTP(true);
        setIsLoading(false);
      })
      .catch((err) => {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;

        setInvalidOTP(true);
        setOtpVerifyLoader(false);
        setOpacityClass('');
        setErrorMessage('Email retry exhausted! Please wait for few minuntes before retry');
        setShouldTriggerOTP(false);
        setIsLoading(false);
        showServiceError({
          show: true,
          data: errorMsg,
          redirect: false
        });
      });
  };

  const sendOTP = () => {
    setShouldTriggerOTP(true);
    setSentEmailId(() => {
      return emailId.key;
    });
    initiateOTP();
  };

  const selectedEmailId = (value) => {
    setSelectedEmailId(value);
  };

  const handleReviewersList = (updatedReviewersList) => {
    reviewersList = updatedReviewersList;
  };

  const sendEmail = () => {
    setIsLoading(true);
    setNotification({});
    const reviewerEmails = [];
    Object.entries(reviewersList).map(([_key, value]) => {
      if (value.error.length === 0 && value.added) {
        reviewerEmails.push(value.value);
      }
    });
    // add reviewers feature

    const emails = selectedOption.map((option) => option?.key);

    sendEmailForOrderAuthentication(emails, isMultiSite).then(
      (resp) => {
        setSentEmailId(() => {
          return emailId.key;
        });
        setIsLoading(false);
        hidePopup();

        fetchOrder && fetchOrder();
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
        hidePopup();
      }
    );
  };

  useEffect(() => {
    if (OTP && OTP.length === 4) {
      onSubmit();
    }
  }, [OTP]);

  const onSubmit = () => {
    setInvalidOTP(false);
    let payLoad = {};
    faOnDedicatedEmailPopupSubmit();
    if (OTP.toString().length === 4) {
      payLoad.otpCode = OTP;
      if (emailId && emailId.key) {
        payLoad.emailId = emailId.key;
      }
      verifyOTPForSummary(payLoad, isMultiSite)
        .then((resp) => {
          if (resp && resp.data && resp.data.success) {
            setInvalidOTP(false);
            setOTPVerification(true);
            hidePopup();
          } else {
            setInvalidOTP(true);
            setOtpVerifyLoader(false);
            setOpacityClass('');
            setErrorMessage('Invalid Otp! Please try again');
            setOTPVerification(false);
          }
        })
        .catch((err) => {
          setInvalidOTP(true);
          setOtpVerifyLoader(false);
          setOpacityClass('');
          setErrorMessage('Invalid Otp! Please try again');
          setOTPVerification(false);
        });
    }
  };

  const resendOTP = () => {
    setShouldTriggerOTP(true);
    setOTP('');
    initiateOTP();
  };

  const hidePopup = () => {
    setshowPopup(false);
    stopBackgroundScrolling(false);
  };

  const isOTPBtnEnabled = () => {
    return (emailId && emailId.isCurrentUser) || isOrderConfirmation;
  };

  const onRefreshClick = () => {
    if (refreshing) return;
    setRefreshing(true);
    getOrderConfirmationUsers(isMultiSite)
      .then((response) => {
        let customerData = response?.data?.result ? response.data.result : customer;
        if (checkIfObjectHasValue(customerData)) {
          const otherContacts = customerData?.otherContacts ? customerData.otherContacts : [];
          const userEmail = customerData && customerData.journeyInitiator && customerData.journeyInitiator.email;
          setOptionsList(getOptionListForEmail(customerData, isOrderConfirmation, email));
          setCustomerDetail(customerData);
          let selectedContact = {
            displayName: otherContacts[0]?.designation + ' | ' + otherContacts[0]?.email,
            key: otherContacts[0]?.email,
            isCurrentUser: userEmail === otherContacts[0]?.email
          };
          setSelectedEmailId(selectedContact);
        }
        setRefreshing(false);
      })
      .catch((err) => {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
        setRefreshing(false);
        showServiceError({
          show: true,
          data: errorMsg,
          redirect: false
        });
      });
  };

  const onMultiSelectChange = (changedOptions = []) => {
    changedOptions.length < 6 && setSelectedOption(changedOptions);
  };

  useEffect(() => {
    stopBackgroundScrolling(true);

    if (isAOIOrder()) {
      initiateOTP();
    }
    const order = getCurrentOrder();
    faOnDedicatedEmailPopupLoad(order, planDetail);
  }, []);

  if (isAOIOrder()) {
    return (
      <div className="drawerSection">
        <div className="popup-section cancelOrder">
          <h2>Confirm Order</h2>
          <span className="material-icons close-email-popup" onClick={() => hidePopup()}>
            close
          </span>
          <React.Fragment>
            <p className="grey-text">
              <p>
                To confirm the order, please send the 4-digit OTP code to your email address <b style={{ fontWeight: 'bold' }}>{emailId?.key}.</b>
              </p>
              {/* {getEmailHeaderText(sentEmailId, orderStatus, isOrderConfirmation, shouldTriggerOTP, isOTPBtnEnabled())} */}
              {/* {shouldTriggerOTP && !isOrderConfirmation ? (
                <span className={'link-name'} onClick={() => setShouldTriggerOTP(false)}>
                  Edit
                </span>
              ) : (
                ''
              )} */}
            </p>
            <div className="otpInput ">
              <div className={`status ${invalidOTP ? 'error' : OTP && OTP.length === 4 ? 'success' : ''}`}>
                <div className="otp-input-root">
                  <OTPInput value={OTP} onChange={onChangeOTP} autoFocus OTPLength={4} otpType="number" disabled={false} secure={false} />
                </div>
              </div>
              <div className="resend" onClick={resendOTP}>
                Resend OTP <span className="arrow" />
              </div>
              {invalidOTP && <div className="error">{errorMessage}</div>}
            </div>

            {/* <div className="characters">&nbsp;</div> */}
            <div className="buttonSection flex-start">
              {isOTPBtnEnabled() && !shouldTriggerOTP && (
                <Button className="btn activebtn" disabled={isLoading} onClick={sendOTP}>
                  {' '}
                  Send OTP
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              )}
            </div>
          </React.Fragment>
        </div>
      </div>
    );
  }

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder">
        <h2>Confirm Order</h2>
        <span className="material-icons close-email-popup" onClick={() => hidePopup()}>
          close
        </span>
        {optionsList && optionsList.length > 0 ? (
          <React.Fragment>
            <p className="grey-text">
              {getEmailHeaderText(sentEmailId, orderStatus, isOrderConfirmation, shouldTriggerOTP, isOTPBtnEnabled())}
              {shouldTriggerOTP && !isOrderConfirmation ? (
                <span className={'link-name'} onClick={() => setShouldTriggerOTP(false)}>
                  Edit
                </span>
              ) : (
                ''
              )}
            </p>
            {shouldTriggerOTP ? (
              <div className="otpInput ">
                <div className={`status ${invalidOTP ? 'error' : OTP && OTP.length === 4 ? 'success' : ''}`}>
                  <div className="otp-input-root">
                    <OTPInput value={OTP} onChange={onChangeOTP} autoFocus OTPLength={4} otpType="number" disabled={false} secure={false} />
                  </div>
                </div>
                <div className="resend" onClick={resendOTP}>
                  Resend OTP <span className="arrow" />
                </div>
                {invalidOTP && <div className="error">{errorMessage}</div>}
              </div>
            ) : (
              <div className="email-selection-list">
                {isOrderConfirmation ? (
                  <Select label={'Select Email'} value={emailId} onChange={(value) => selectedEmailId(value)} options={optionsList} required />
                ) : (
                  <>
                    <MultiSelectDropDownWithSearch
                      label="Select authorised signatory"
                      value={selectedOption}
                      onChange={onMultiSelectChange}
                      optionsList={optionsList}
                      selectedOption={selectedOption}
                      setSelectedOption={setSelectedOption}
                    ></MultiSelectDropDownWithSearch>
                  </>
                )}
                {!isOTPBtnEnabled() ? (
                  <div className="refresh-wrapper">
                    {' '}
                    <img
                      onClick={onRefreshClick}
                      src={refreshIcon}
                      className={classNames({
                        refresh_btn: true,
                        active: refreshing
                      })}
                    />
                  </div>
                ) : null}
                {/* <AddReviewer getUpdatedList={(reviewersList) => handleReviewersList(reviewersList)} /> */}
              </div>
            )}

            {/* <div className="characters">&nbsp;</div> */}
            <div className="buttonSection flex-start">
              {isOTPBtnEnabled() && !shouldTriggerOTP && (
                <Button className="btn activebtn" disabled={isLoading} onClick={sendOTP}>
                  {' '}
                  Send OTP
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              )}

              {!isOTPBtnEnabled() && (
                <Button disabled={isLoading || selectedOption?.length === 0 || selectedOption?.length > 5} className="btn activebtn" onClick={sendEmail}>
                  Send Link
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              )}
            </div>
          </React.Fragment>
        ) : (
          <p>
            No Authorized Signatory or Billing Contact available in the system for OTP verification. Please raise a Service Request or contact your KAM to get the details updated.
            Kindly place the order after the contact details are updated.
          </p>
        )}
      </div>
    </div>
  );
};

export default EmailPopup;
